// import 'bootstrap-datepicker'

export default {
	init() {
		// // JavaScript to be fired on the single restavracija page
		// let isTedenRestavracijRezervacije = true //TEMP
		// // let dateRange = false //TEMP


		// JavaScript to be fired on all pages
		// if (typeof isTedenRestavracijRezervacije !== 'undefined' && isTedenRestavracijRezervacije) {
		// 	var dateRangeTmp = JSON.parse(dateRange)
		// 	var enableDatesArray = []
		// 	var sortDatesArry = []
		// 	for (var i = 0; i < dateRangeTmp.length; i++) {
		// 		var dt = dateRangeTmp[i].replace("-", "/").replace("-", "/")
		// 		var dd, mm, yyy
		// 		if (parseInt(dt.split("/")[0]) <= 9 ||parseInt(dt.split("/")[1]) <= 9) {
		// 			dd = parseInt(dt.split("/")[0])
		// 			mm = parseInt(dt.split("/")[1])
		// 			yyy = dt.split("/")[2]
		// 			enableDatesArray.push(dd + "/" + mm + "/" + yyy)
		// 			sortDatesArry.push(
		// 				new Date(yyy +"/" +dt.split("/")[1] +"/" +dt.split("/")[0])
		// 			)
		// 		} else {
		// 			enableDatesArray.push(dt)
		// 			sortDatesArry.push(
		// 				new Date(dt.split("/")[2] +"/" +dt.split("/")[1] +"/" +dt.split("/")[0] +"/")
		// 			)
		// 		}
		// 	}
		// 	var maxDt = new Date(Math.max.apply(null, sortDatesArry))
		// 	var minDt = new Date(Math.min.apply(null, sortDatesArry))

		// 	$(".datepicker").datepicker({
		// 		format: "dd/mm/yyyy",
		// 		autoclose: true,
		// 		startDate: minDt,
		// 		endDate: maxDt,
		// 		beforeShowDay: function (date) {
		// 			var dt_ddmmyyyy = date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
		// 			return enableDatesArray.indexOf(dt_ddmmyyyy) != -1
		// 		}
		// 	})
		// } else {
		// 	$(".datepicker").datepicker({
		// 		format: "dd/mm/yyyy",
		// 	})
		// }



		$("#menu-description li a").on("click", function (e) {
			e.preventDefault()
			const desc = $(this).data("num")
			$(".box-description-item").hide()
			$('*[data-description-item="' + desc + '"]').show()

			$([document.documentElement, document.body]).animate(
				{
					scrollTop: $(".box-description-items").offset().top - 120,
				},500)
		})


		$("#reservation-submit").on('click', function () {
			$("#reservation-submit").prop("disabled", true)
			$(".form-error").removeClass("form-error")
			$(".form-errors-notice, .form-success-notice, .gdpr-error-group").hide()
			let errors = []

			let ime = $("#ime")
			let priimek = $("#priimek")
			let email = $("#email")
			let telefonska = $("#telefonska")
			let datum_od = $("#datum_od")
			let ura = $("#ura")
			let st_oseb = $("#st_oseb")
			let opombe = $("#opombe")
			let gdpr = $("#gdpr")
			let gdprumop = $("#gdprumop")

			if (!checkField(ime)) {
				ime.parent().addClass("form-error")
				errors.push("ime")
			}

			if (!checkField(priimek)) {
				priimek.parent().addClass("form-error")
				errors.push("priimek")
			}

			if (!checkField(email)) {
				email.parent().addClass("form-error")
				errors.push("email")
			}

			//Validate email
			if (email.val() != "") {
				if (!validateEmail(email.val())) {
					email.parent().addClass("form-error")
					errors.push("email-validation")
				}
			}

			if (!checkField(telefonska)) {
				telefonska.parent().addClass("form-error")
				errors.push("telefonska")
			}

			if (!checkField(datum_od) || datum_od.val() == null) {
				datum_od.parent().addClass("form-error")
				errors.push("datum_od")
			}

			if (!checkField(ura)) {
				ura.parent().addClass("form-error")
				errors.push("ura")
			}

			if (!checkField(st_oseb)) {
				st_oseb.parent().addClass("form-error")
				errors.push("st_oseb")
			}

			// obvezni soglasji: .form-error na label (glej _vivi-consent.scss)
			if (!gdpr.is(":checked")) {
				gdpr.parent().addClass("form-error")
				errors.push("gdpr")
			}

			if (!gdprumop.is(":checked")) {
				gdprumop.parent().addClass("form-error")
				errors.push("gdprumop")
			}

			//CHECK IF ALL GOOD
			if (errors.length == 0) {
				var data = jQuery("#reservation-form").serialize()
				var action = "saveAndSendReservation"
				data += "&action=" + action

				jQuery.ajax({
					type: "POST",
					dataType: "json",
					url: my_ajax_object.ajax_url,
					data: data,
					complete: function (json) {
						jQuery("#reservation-submit").prop("disabled", false)

						var jsonData = json.responseJSON || JSON.parse(json.responseText || "{}")

						if (jsonData["status"] == true) {
							jQuery("#reservation-form").trigger("reset")
							jQuery("#hos").hide()
							jQuery(".form-success-notice").show()
						}
					}
				})
			} else {
				jQuery(".form-errors-notice").show()
				jQuery("#reservation-submit").prop("disabled", false)
			}
		})

		/////////// POSEBNA PONUDBA ////////////
		/////////// POSEBNA PONUDBA ////////////
		/////////// POSEBNA PONUDBA ////////////
		/////////// POSEBNA PONUDBA ////////////
		/////////// POSEBNA PONUDBA ////////////

		// $("#reservation-submit-pp").on('click', function () {
		// 	$("#reservation-submit-pp").prop("disabled", true)
		// 	$(".form-error").removeClass("form-error")
		// 	$(".form-errors-notice, .form-success-notice, .gdpr-error-group").hide()
		// 	let errors = []

		// 	let ime = $("#invite-pp-ime")
		// 	let priimek = $("#invite-pp-priimek")
		// 	let naslov = $("#invite-pp-naslov")
		// 	let postna_st = $("#invite-pp-postna-st")
		// 	let kraj = $("#invite-pp-kraj")
		// 	let email = $("#invite-pp-email")
		// 	let st_oseb = $("#invite-pp-st-oseb")
		// 	let nacin_placila = $('input[name="invite-pp-tip-placila"]:checked')
		// 	let gdpr = $("#gdpr-pp")
		// 	console.log(nacin_placila.val())

		// 	if (!checkField(ime)) {
		// 		ime.parent().addClass("form-error")
		// 		errors.push("ime")
		// 	}

		// 	if (!checkField(priimek)) {
		// 		priimek.parent().addClass("form-error")
		// 		errors.push("priimek")
		// 	}

		// 	if (!checkField(naslov)) {
		// 		naslov.parent().addClass("form-error")
		// 		errors.push("naslov")
		// 	}

		// 	if (!checkField(postna_st)) {
		// 		postna_st.parent().addClass("form-error")
		// 		errors.push("postna_st")
		// 	}

		// 	if (!checkField(kraj)) {
		// 		kraj.parent().addClass("form-error")
		// 		errors.push("kraj")
		// 	}

		// 	if (!checkField(email)) {
		// 		email.parent().addClass("form-error")
		// 		errors.push("email")
		// 	}

		// 	//Validate email
		// 	if (email.val() != "") {
		// 		if (!validateEmail(email.val())) {
		// 			email.parent().addClass("form-error")
		// 			errors.push("email-validation")
		// 		}
		// 	}

		// 	if (!checkField(st_oseb)) {
		// 		st_oseb.parent().addClass("form-error")
		// 		errors.push("st_oseb")
		// 	}

		// 	if (!gdpr.is(":checked")) {
		// 		gdpr.parent().addClass("form-error")
		// 		errors.push("gdpr-pp")
		// 	}

		// 	//CHECK IF ALL GOOD
		// 	if (errors.length == 0) {
		// 		var data = jQuery("#reservation-form-pp").serialize()
		// 		var action = "saveAndSendPosebnaPonudba"
		// 		data += "&action=" + action

		// 		jQuery.ajax({
		// 			type: "POST",
		// 			dataType: "json",
		// 			url: my_ajax_object.ajax_url,
		// 			data: data,
		// 			complete: function (json) {
		// 				jQuery("#reservation-submit-pp").prop("disabled",false,)
		// 				if (nacin_placila.val() == "paypal") {
		// 					$("#paypal-pp form").trigger("submit")
		// 				}
		// 				console.log(nacin_placila.val())

		// 				var jsonData = jQuery.parseJSON(json.responseText)
		// 				console.log(json)

		// 				if (jsonData["status"] == true) {
		// 					jQuery("#reservation-form-pp").trigger("reset")
		// 					jQuery(".form-success-notice").show()
		// 				}
		// 			},
		// 		})
		// 	} else {
		// 		jQuery(".form-errors-notice").show()
		// 		jQuery("#reservation-submit-pp").prop("disabled", false)
		// 	}
		// })

		// Popup for Posebna ponudba
		// var ppPrice = 0
		// $(".popup-pp").on('click', function () {
		// 	var title = $(this).data("title")
		// 	var price = $(this).data("price")
		// 	var ppdatetime = $(this).data("datetimepp")

		// 	$("#popup-pp-title").text(title)
		// 	$(".popup-pp-datetime").text(ppdatetime)
		// 	$("#invite-pp-ime-ponudbe").val(title)
		// 	$("#popup-pp-price, #popup-pp-title-price").text(price)
		// 	$('#paypal-pp form input[name="amount"]').val(price)
		// 	ppPrice = price
		// })

		// $("#invite-pp-st-oseb").on("input", function () {
		// 	var quantity = $(this).val()

		// 	if (quantity < 1) {
		// 		quantity = 1
		// 		$(this).val(quantity)
		// 	}

		// 	var totalPrice = ppPrice * quantity

		// 	$("#popup-pp-price, #popup-pp-title-price").text(totalPrice)
		// 	$('#paypal-pp form input[name="amount"]').val(totalPrice)
		// 	$("#invite-pp-total-price").val(totalPrice)
		// })

		/////////// END OF POSEBNA PONUDBA ////////////
		/////////// END OF POSEBNA PONUDBA ////////////
		/////////// END OF POSEBNA PONUDBA ////////////
		/////////// END OF POSEBNA PONUDBA ////////////
		/////////// END OF POSEBNA PONUDBA ////////////

		/////////// POSEBNI GOST ////////////
		/////////// POSEBNI GOST ////////////
		/////////// POSEBNI GOST ////////////
		/////////// POSEBNI GOST ////////////
		/////////// POSEBNI GOST ////////////

		// $("#reservation-submit-pg").on('click', function () {
		// 	$("#reservation-submit-pg").prop("disabled", true)
		// 	$(".form-error").removeClass("form-error")
		// 	$(".form-errors-notice, .form-success-notice, .gdpr-error-group",).hide()
		// 	let errors = []

		// 	let ime = $("#invite-pg-ime")
		// 	let priimek = $("#invite-pg-priimek")
		// 	let naslov = $("#invite-pg-naslov")
		// 	let postna_st = $("#invite-pg-postna-st")
		// 	let kraj = $("#invite-pg-kraj")
		// 	let email = $("#invite-pg-email")
		// 	let st_oseb = $("#invite-pg-st-oseb")
		// 	let gdpr = $("#gdpr-pg")
		// 	let company_invoice = $("#company-invoice-pg")
		// 	let company_ime = $("#invite-pg-ime-podjetja")
		// 	let company_davcna = $("#invite-pg-davcna-podjetja")
		// 	let company_telefon = $("#invite-pg-telefon-podjetja")
		// 	let nacin_placila = $('input[name="invite-pg-tip-placila"]:checked')

		// 	if (!checkField(ime)) {
		// 		ime.parent().addClass("form-error")
		// 		errors.push("ime")
		// 	}

		// 	if (!checkField(priimek)) {
		// 		priimek.parent().addClass("form-error")
		// 		errors.push("priimek")
		// 	}

		// 	if (!checkField(naslov)) {
		// 		naslov.parent().addClass("form-error")
		// 		errors.push("naslov")
		// 	}

		// 	if (!checkField(postna_st)) {
		// 		postna_st.parent().addClass("form-error")
		// 		errors.push("postna_st")
		// 	}

		// 	if (!checkField(kraj)) {
		// 		kraj.parent().addClass("form-error")
		// 		errors.push("kraj")
		// 	}

		// 	if (!checkField(email)) {
		// 		email.parent().addClass("form-error")
		// 		errors.push("email")
		// 	}

		// 	//Validate email
		// 	if (email.val() != "") {
		// 		if (!validateEmail(email.val())) {
		// 			email.parent().addClass("form-error")
		// 			errors.push("email-validation")
		// 		}
		// 	}

		// 	if (!checkField(st_oseb)) {
		// 		st_oseb.parent().addClass("form-error")
		// 		errors.push("st_oseb")
		// 	}

		// 	if (company_invoice.is(":checked")) {
		// 		console.log("ASD")
		// 		if (!checkField(company_ime)) {
		// 			company_ime.parent().addClass("form-error")
		// 			errors.push("company_ime")
		// 		}

		// 		if (!checkField(company_davcna)) {
		// 			company_davcna.parent().addClass("form-error")
		// 			errors.push("company_davcna")
		// 		}

		// 		if (!checkField(company_telefon)) {
		// 			company_telefon.parent().addClass("form-error")
		// 			errors.push("company_telefon")
		// 		}
		// 	}

		// 	if (!gdpr.is(":checked")) {
		// 		gdpr.parent().addClass("form-error")
		// 		errors.push("gdpr-pg")
		// 	}

		// 	//CHECK IF ALL GOOD
		// 	if (errors.length == 0) {
		// 		var data = jQuery("#reservation-form-pg").serialize()
		// 		var action = "saveAndSendPosebniGost"
		// 		data += "&action=" + action

		// 		jQuery.ajax({
		// 			type: "POST",
		// 			dataType: "json",
		// 			url: my_ajax_object.ajax_url,
		// 			data: data,
		// 			complete: function (json) {
		// 				jQuery("#reservation-submit-pg").prop("disabled",false)
		// 				if (nacin_placila.val() == "paypal") {
		// 					$("#paypal-pg form").trigger("submit")
		// 				}
		// 				console.log(nacin_placila.val())

		// 				var jsonData = jQuery.parseJSON(json.responseText)
		// 				console.log(json)

		// 				if (jsonData["status"] == true) {
		// 					jQuery("#reservation-form-pg").trigger("reset")
		// 					jQuery(".form-success-notice").show()
		// 				}
		// 			},
		// 		})
		// 	} else {
		// 		jQuery(".form-errors-notice").show()
		// 		jQuery("#reservation-submit-pg").prop("disabled", false)
		// 	}
		// })

		// // Popup for Posebni gost
		// var pgPrice = 0
		// $(".popup-pg").on('click', function () {
		// 	var title = $(this).data("title")
		// 	var price = $(this).data("price")
		// 	var until = $(this).data("until")
		// 	var text = $(this).data("text")

		// 	$("#popup-pg-title").text(title)

		// 	$("#popup-pg-until").text(until)
		// 	$("#popup-pg-text").text(text)

		// 	$("#invite-pg-until").val(until)
		// 	$("#invite-pg-text").val(text)

		// 	$("#invite-pg-ime-ponudbe").val(title)
		// 	$("#popup-pg-price, #popup-pg-title-price").text(price)
		// 	$('#paypal-pg form input[name="amount"]').val(price)
		// 	pgPrice = price
		// })

		// $("#invite-pg-st-oseb").on("input", function () {
		// 	var quantity = $(this).val()

		// 	if (quantity < 1) {
		// 		quantity = 1
		// 		$(this).val(quantity)
		// 	}

		// 	var totalPrice = pgPrice * quantity

		// 	$("#popup-pg-price, #popup-pg-title-price").text(totalPrice)
		// 	$('#paypal-pg form input[name="amount"]').val(totalPrice)
		// 	$("#invite-pg-total-price").val(totalPrice)
		// })

		/////////// END OF POSEBNI GOST ////////////
		/////////// END OF POSEBNI GOST ////////////
		/////////// END OF POSEBNI GOST ////////////
		/////////// END OF POSEBNI GOST ////////////
		/////////// END OF POSEBNI GOST ////////////

		/////////// DARILNI BON ////////////
		/////////// DARILNI BON ////////////
		/////////// DARILNI BON ////////////
		/////////// DARILNI BON ////////////
		/////////// DARILNI BON ////////////

		// $("#reservation-submit-db").on('click', function () {
		// 	$("#reservation-submit-db").prop("disabled", true)
		// 	$(".form-error").removeClass("form-error")
		// 	$(".form-errors-notice, .form-success-notice, .gdpr-error-group").hide()
		// 	let errors = []

		// 	let ime = $("#invite-db-ime")
		// 	let priimek = $("#invite-db-priimek")
		// 	let naslov = $("#invite-db-naslov")
		// 	let postna_st = $("#invite-db-postna-st")
		// 	let kraj = $("#invite-db-kraj")
		// 	let email = $("#invite-db-email")
		// 	let st_oseb = $("#invite-db-st-oseb")
		// 	let gdpr = $("#gdpr-db")
		// 	let company_invoice = $("#company-invoice-db")
		// 	let company_ime = $("#invite-db-ime-podjetja")
		// 	let company_davcna = $("#invite-db-davcna-podjetja")
		// 	let company_telefon = $("#invite-db-telefon-podjetja")
		// 	let nacin_placila = $('input[name="invite-db-tip-placila"]:checked')

		// 	if (!checkField(ime)) {
		// 		ime.parent().addClass("form-error")
		// 		errors.push("ime")
		// 	}

		// 	if (!checkField(priimek)) {
		// 		priimek.parent().addClass("form-error")
		// 		errors.push("priimek")
		// 	}

		// 	if (!checkField(naslov)) {
		// 		naslov.parent().addClass("form-error")
		// 		errors.push("naslov")
		// 	}

		// 	if (!checkField(postna_st)) {
		// 		postna_st.parent().addClass("form-error")
		// 		errors.push("postna_st")
		// 	}

		// 	if (!checkField(kraj)) {
		// 		kraj.parent().addClass("form-error")
		// 		errors.push("kraj")
		// 	}

		// 	if (!checkField(email)) {
		// 		email.parent().addClass("form-error")
		// 		errors.push("email")
		// 	}

		// 	//Validate email
		// 	if (email.val() != "") {
		// 		if (!validateEmail(email.val())) {
		// 			email.parent().addClass("form-error")
		// 			errors.push("email-validation")
		// 		}
		// 	}

		// 	if (!checkField(st_oseb)) {
		// 		st_oseb.parent().addClass("form-error")
		// 		errors.push("st_oseb")
		// 	}

		// 	if (company_invoice.is(":checked")) {
		// 		console.log("ASD")
		// 		if (!checkField(company_ime)) {
		// 			company_ime.parent().addClass("form-error")
		// 			errors.push("company_ime")
		// 		}

		// 		if (!checkField(company_davcna)) {
		// 			company_davcna.parent().addClass("form-error")
		// 			errors.push("company_davcna")
		// 		}

		// 		if (!checkField(company_telefon)) {
		// 			company_telefon.parent().addClass("form-error")
		// 			errors.push("company_telefon")
		// 		}
		// 	}

		// 	if (!gdpr.is(":checked")) {
		// 		gdpr.parent().addClass("form-error")
		// 		errors.push("gdpr-db")
		// 	}

		// 	//CHECK IF ALL GOOD
		// 	if (errors.length == 0) {
		// 		var data = jQuery("#reservation-form-db").serialize()
		// 		var action = "saveAndSendDarilniBon"
		// 		data += "&action=" + action

		// 		jQuery.ajax({
		// 			type: "POST",
		// 			dataType: "json",
		// 			url: my_ajax_object.ajax_url,
		// 			data: data,
		// 			complete: function (json) {
		// 				jQuery("#reservation-submit-db").prop(
		// 					"disabled",
		// 					false,
		// 				)
		// 				if (nacin_placila.val() == "paypal") {
		// 					$("#paypal-db form").trigger("submit")
		// 				}
		// 				console.log(nacin_placila.val())

		// 				var jsonData = jQuery.parseJSON(json.responseText)
		// 				console.log(json)

		// 				if (jsonData["status"] == true) {
		// 					jQuery("#reservation-form-pg").trigger("reset")
		// 					jQuery(".form-success-notice").show()
		// 				}
		// 			}
		// 		})
		// 	} else {
		// 		jQuery(".form-errors-notice").show()
		// 		jQuery("#reservation-submit-pg").prop("disabled", false)
		// 	}
		// })

		// // Popup for Posebni gost
		// var dbPrice = 0
		// $(".popup-db").on('click', function () {
		// 	var title = $(this).data("title")
		// 	var price = $(this).data("price")
		// 	var until = $(this).data("until")
		// 	var text = $(this).data("text")

		// 	$("#popup-db-title").text(title)

		// 	$("#popup-db-until").text(until)
		// 	$("#popup-db-text").text(text)

		// 	$("#invite-db-until").val(until)
		// 	$("#invite-db-text").val(text)

		// 	$("#invite-db-ime-ponudbe").val(title)
		// 	$("#popup-db-price, #popup-db-title-price").text(price)
		// 	$('#paypal-db form input[name="amount"]').val(price)
		// 	dbPrice = price
		// })

		// $("#invite-db-st-oseb").on("input", function () {
		// 	var quantity = $(this).val()

		// 	if (quantity < 1) {
		// 		quantity = 1
		// 		$(this).val(quantity)
		// 	}

		// 	var totalPrice = dbPrice * quantity

		// 	$("#popup-db-price, #popup-db-title-price").text(totalPrice)
		// 	$('#paypal-db form input[name="amount"]').val(totalPrice)
		// 	$("#invite-db-total-price").val(totalPrice)
		// })

		/////////// END OF DARILNI BON ////////////
		/////////// END OF DARILNI BON ////////////
		/////////// END OF DARILNI BON ////////////
		/////////// END OF DARILNI BON ////////////
		/////////// END OF DARILNI BON ////////////

		// $("#company-invoice-pg").on('change', function () {
		// 	if ($(this).is(":checked")) {
		// 		$(".company-wrapper-pg").addClass("show")
		// 	} else {
		// 		$(".company-wrapper-pg").removeClass("show")
		// 	}
		// })

		// $("#company-invoice-pp").on('change', function () {
		// 	if ($(this).is(":checked")) {
		// 		$(".company-wrapper-pp").addClass("show")
		// 	} else {
		// 		$(".company-wrapper-pp").removeClass("show")
		// 	}
		// })

		// single restaurant PP, PG, DB tab menu
		// let vabiloActiveTab = ""
		// function is_mobile() {
		// 	if ($("body").width() < 767) {
		// 		return true
		// 	}
		// 	return false
		// }
		// function get_vabiloStart() {
		// 	return $(".vabilo-wraper").offset().top - screen.height / 2
		// }
		// function get_vabiloEnd() {
		// 	return (
		// 		$(".vabilo-wraper").offset().top +
		// 		$(".vabilo-wraper").outerHeight() +
		// 		$("#mainNav").outerHeight() * 2 -
		// 		screen.height / 2
		// 	)
		// }
		// $(window).scroll(function () {
		// 	if (is_mobile()) {
		// 		if (
		// 			$(".vabilo-wraper .vabilo-contents .box-invite.active")
		// 				.length
		// 		) {
		// 			if (
		// 				window.scrollY > get_vabiloStart() &&
		// 				window.scrollY < get_vabiloEnd()
		// 			) {
		// 				$(".btn-mobile-reserve").hide()
		// 				$(
		// 					".vabilo-wraper .vabilo-contents .box-invite.active." +
		// 						vabiloActiveTab,
		// 				).css({ opacity: "1" })
		// 			} else {
		// 				$(".btn-mobile-reserve").show()
		// 				$(
		// 					".vabilo-wraper .vabilo-contents .box-invite.active." +
		// 						vabiloActiveTab,
		// 				).css({ opacity: "0.2" })
		// 			}
		// 		}
		// 	}
		// })
		// $(document).on("click",'.vabilo-wraper .vabilo-menu .filter-checkbox-button input[type="checkbox"]', function (e) {
		// 		e.stopPropagation()
		// 		let name = $(this).attr("name")
		// 		vabiloActiveTab = name

		// 		// highlight menu tab, open/close menu content
		// 		function toggleVabilo() {
		// 			if ($(".vabilo-wraper .vabilo-menu .filter-checkbox-button." +name +' input[type="checkbox"]',).prop("checked")) {
		// 				$(".vabilo-wraper .vabilo-menu .filter-checkbox-button." + name).addClass("active")
		// 				$(".vabilo-wraper .vabilo-contents .restaurant-box." +name).slideDown("slow", function () {
		// 					$(this).addClass("active")
		// 					$('.vabilo-wraper .vabilo-menu .filter-checkbox-button input[type="checkbox"]').prop("disabled", false)
		// 				})
		// 			} else {
		// 				$(".vabilo-wraper .vabilo-menu .filter-checkbox-button." +name,).removeClass("active")
		// 				$(".vabilo-wraper .vabilo-contents .box-invite." + name).removeClass("active").slideUp("slow")
		// 				$('.vabilo-wraper .vabilo-menu .filter-checkbox-button input[type="checkbox"]').prop("disabled", false)
		// 			}
		// 		}

		// 		// remove active
		// 		$('.vabilo-wraper .vabilo-menu .filter-checkbox-button input[type="checkbox"]',).prop("disabled", true)
		// 		$('.vabilo-wraper .vabilo-menu .filter-checkbox-button.active input[type="checkbox"]',).prop("checked", false)
		// 		$(".vabilo-wraper .vabilo-menu .filter-checkbox-button.active",).removeClass("active")

		// 		if ($(".vabilo-wraper .vabilo-contents .box-invite.active").length && !$(".vabilo-wraper .vabilo-contents .box-invite.active").hasClass(name)) {
		// 			$(".vabilo-wraper .vabilo-contents .box-invite.active")
		// 				.removeClass("active")
		// 				.slideUp("slow", function () {
		// 					toggleVabilo()
		// 				})
		// 		}

		// 		toggleVabilo()
		// 	},
		// )
	},
}

function checkField(field) {
	if (field.val() == "") {
		return false
	}
	return true
}

function validateEmail(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	return re.test(String(email).toLowerCase())
}
